import { GmdWidgetProps } from "@app/projects/network-assessment/gap-management-dashboard/interfaces/gmdWidgetProps";
import { FillabilityBreakdownWidget } from "@app/projects/network-assessment/gap-management-dashboard/components/FillabilityBreakdownWidget";
import { GapOverviewWidget } from "@app/projects/network-assessment/gap-management-dashboard/components/GapOverviewWidget";
import { PriorityDistributionWidget } from "@app/projects/network-assessment/gap-management-dashboard/components/PriorityDistributionWidget";
import { ResolutionStatusWidget } from "@app/projects/network-assessment/gap-management-dashboard/components/ResolutionStatusWidget";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QesColors } from "@app/shared/qes-standards/colors";
import { FC } from "react";

const loadingIcon = <QesIcon iconName={QesIcons.LoadingV1} description="loading" className="qes-icon-spin" color={QesColors.QesTertiaryGreen2} />;
const errorBanner = <QESAlert type="danger" persist={true}>We encountered an error loading this data.</QESAlert>;

export const GapManagementDashboard: FC = () => {
  const widgetProps: GmdWidgetProps = { errorBanner, loadingIcon };

  return (
    <div className="gap-management-dashboard__grid">
      <div className="gap-management-dashboard__filters-row">
        <QESButton
          qesType="outline-inherit"
          qesTestId="gap-management-dashboard__filters"
          disabled
        >
          <QesIcon iconName={QesIcons.FilterLines} isDecorative style={{ verticalAlign: "text-top" }} /> Filters
        </QESButton>
      </div>

      <div className="gap-management-dashboard__summary-row">
        <GapOverviewWidget {...widgetProps} />
        <FillabilityBreakdownWidget {...widgetProps} />
        <ResolutionStatusWidget {...widgetProps} />
        <PriorityDistributionWidget {...widgetProps} />
      </div>

      {/* The table is in a separate component, because we want the ability to hide the tiles
        via the "Show Charts" toggle, but keep the table visible 
        */}
    </div >
  )
}